import { alertMessages, inboxConstants } from "_constants";
import { inboxService } from "_services";
import { SnackBar } from "../components/common";

function getOrgInboxMessages(params) {
  const request = () => ({
    type: inboxConstants.GET_ORG_INBOX_MESSAGES_REQUEST,
  });

  const success = (payload) => ({
    type: inboxConstants.GET_ORG_INBOX_MESSAGES_SUCCESS,
    payload: payload,
  });

  const failure = (error) => ({
    type: inboxConstants.GET_ORG_INBOX_MESSAGES_FAILURE,
    payload: error,
  });

  return (dispatch) => {
    dispatch(request());

    inboxService.getOrgInboxMessages(params).then(
      (message) => dispatch(success(message?.data)),
      (error) => {
        dispatch(failure(error));
        SnackBar.showMessage(alertMessages.GENERIC_ERROR);
      },
    );
  };
}

function getParentPost(messageId) {
  const request = () => ({
    type: inboxConstants.GET_PARENT_POST_REQUEST,
  });

  const success = (payload) => ({
    type: inboxConstants.GET_PARENT_POST_SUCCESS,
    payload: payload,
  });

  const failure = (error) => ({
    type: inboxConstants.GET_PARENT_POST_FAILURE,
    payload: error,
  });

  return (dispatch) => {
    dispatch(request());

    inboxService.getParentPost(messageId).then(
      (response) => dispatch(success(response?.data)),
      (error) => dispatch(failure(error)),
    );
  };
}

function lockMessage(messageId, options = {}) {
  const request = () => ({
    type: inboxConstants.LOCK_MESSAGE_REQUEST,
    keepExisting: options.keepExisting,
  });

  const success = (payload) => ({
    type: inboxConstants.LOCK_MESSAGE_SUCCESS,
    payload: payload,
  });

  const failure = (error) => ({
    type: inboxConstants.LOCK_MESSAGE_FAILURE,
    payload: error,
  });

  return (dispatch) => {
    dispatch(request());

    inboxService.lockMessage(messageId).then(
      (response) => dispatch(success(response?.data)),
      (error) => dispatch(failure(error)),
    );
  };
}

function regenerateReply(messageId) {
  const request = () => ({
    type: inboxConstants.REGENERATE_REPLY_REQUEST,
  });

  const success = (payload) => ({
    type: inboxConstants.REGENERATE_REPLY_SUCCESS,
    payload: payload,
  });

  const failure = (error) => ({
    type: inboxConstants.REGENERATE_REPLY_FAILURE,
    payload: error,
  });

  return (dispatch) => {
    dispatch(request());

    inboxService.regenerateReply(messageId).then(
      (response) => dispatch(success(response?.data)),
      (error) => {
        dispatch(failure(error));
        SnackBar.showMessage(alertMessages.GENERIC_ERROR);
      },
    );
  };
}

export const inboxActions = {
  getOrgInboxMessages,
  getParentPost,
  lockMessage,
  regenerateReply,
};
